export default __webpack_public_path__ + "static/media/apple.ab9c1a2d.png";